var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"},[(_vm.confirm)?_c('div',{staticClass:"logout-content"},[_c('b-spinner',{attrs:{"type":"grow","label":"Loading..."}}),_c('small',[_vm._v(" Signing Out...")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }